<template>
  <div
    class="incredi-selection-menu-cmp"
    :class="{ 'incredi-selection-menu-disabled': disabled }"
  >
    <label
      v-if="label"
      for="menu-selection"
      class="ibf-amount4 incredi-select-menu--label"
      >{{ label }}</label
    >
    <q-btn
      flat
      class="focus-be-gone ripple-go-away incredi-select-menu-btn"
      :style="{ width: '178px' }"
      :ripple="false"
      no-caps
      :dense="dense"
    >
      <div
        class="menu-selected-option ibf-button2"
        :class="{ 'input-with-menu--menu-open': menu }"
      >
        <span>
          {{ value }}
        </span>
        <svg
          class="field-menu-dropdown-icon"
          width="9"
          height="6"
          viewBox="0 0 9 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 1.5L4.5 4.5L7.5 1.5"
            :stroke="disabled ? '#99A4A7' : '#1B1B1B'"
            stroke-width="2"
            stroke-linecap="square"
          />
        </svg>
      </div>

      <q-menu
        v-model="menuComputed"
        :transition-duration="0"
        :offset="[0, 2.5]"
        fit
        label="selectedOption"
        transition-show="jump-down"
        transition-hide="jump-up"
        :content-class="{ 'menu-layer-order': $attrs.layerOrder, 'incredi-selection-input incredi-select-menu-input brand_almost_black': true }"
        auto-close
      >
        <q-list dense>
          <q-item
            v-for="option in options"
            :key="option"
            class="focus-be-gone incredi-drop-down--q-item"
            style="font-size: 12px"
            :dense="dense"
            clickable
            @click="setSelectedOption(option)"
          >
            <div
              style="display: flex; align-items: center; text-transform: capitalize"
              :class="{
                'ibf-gordita-12-m': value === option,
                'incredi-select-menu-selected': value === option,
              }"
            >
              {{ option }}
            </div>
          </q-item>
        </q-list>
      </q-menu>
    </q-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: String,
    },
    label: {
      type: String,
    },
    disabled: {
      default: false,
    },
    options: {
      required: true,
      type: Array,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    menuComputed: {
      get() {
        if (this.disabled) return false;
        return this.menu;
      },
      set(val) {
        if (!this.disabled) {
          this.menu = val;
        }
      },
    },
  },
  methods: {
    setSelectedOption(option) {
      this.$emit('input', option);
      this.$emit('update:value', option);
    },
  },
};
</script>

<style lang="scss">
.incredi-drop-down--q-item {
  &:hover {
    background-color: $-hovers-hover-primary;
  }
}
.menu-layer-order {
  &.q-menu {
    z-index: 2999;
  }
}
.incredi-selection-menu-disabled {
  color: $-text-text-low-old !important;
  .menu-selected-option {
    color: $-system-app-grey-76 !important;
  }

  .incredi-select-menu-btn {
    cursor: initial !important;
    background-color: $-system-app-background;
  }
}
.incredi-select-menu-selected {
  color: $-text-text-primary;
  display: flex;
}
.incredi-select-menu-input {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2) !important;
  .q-item__section {
    align-items: end !important;
  }
}
.incredi-select-menu--label {
  //styleName: Amount 4 - subtitles;
  color: $-text-text-low-old;
  line-height: 13px;
  letter-spacing: 0em;
  height: 16px;
  margin-bottom: 1px;
}
.incredi-selection-menu-cmp {
  display: flex;
  flex-direction: column;
  .menu-selected-option {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: capitalize;

    > span {
      line-height: 14.64px;
    }
  }
}
.incredi-select-menu-btn {
  border: 1px solid #f0f3f4 !important;

  :deep(.q-btn__wrapper) {
    padding: 8.5px 12px;
    .q-btn__content {
      width: 100%;
    }
    &::before {
      box-shadow: none !important;
    }
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}
</style>
